import React from 'react';
import LogoutContainer from './../../component/user/logout-container';

const render = () => <LogoutContainer />;

export default render;
